import React, { ReactElement } from "react"
import { Box } from "@mui/material"
import Modal from "src/components/Modal"
import Text from "src/components/Text"
import Button from "src/components/Button"

interface ModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function UnstakeLpModal({
  open,
  onClose,
  onConfirm,
}: ModalProps): ReactElement {
  return (
    <Modal title="Remove boost before unstaking" open={open} onClose={onClose}>
      <Text mt={3}>
        Please remove the boosted pools before unstaking LP from the pool.
      </Text>
      <Box mt={3}>
        <Button fullWidth onClick={onConfirm}>
          Remove boost from boost page
        </Button>
        <Button kind="outline" onClick={onClose} fullWidth mt={1}>
          Cancel
        </Button>
      </Box>
    </Modal>
  )
}
